// extracted by mini-css-extract-plugin
export default {"container":"FacilitiesCarousel_container__wz0eu","slide":"FacilitiesCarousel_slide__3H6Un","title":"FacilitiesCarousel_title__n1bwk","slides":"FacilitiesCarousel_slides__Seu6n"};